import { UploadImportFormData } from './UploadImportFormData.types';
import { FetchApi } from '../../api/ApiFetch/ApiFetch';
import { HTTPMethod } from '../../api/ApiFetch/HTTPMethod.types';
import { ServiceType } from '../../api/ApiFetch/ServiceType.types';
import { ApiUrls } from '../../api/ApiConstants/ApiUrls';
import { CreateTextResponse } from '../../api/ApiFetch/ApiResponse';
import { Guid } from 'guid-typescript';

export async function uploadFormData(params: UploadImportFormData): Promise<Response> {
    const formData = new FormData();
    formData.append('DatasetName', params.datasetName);
    formData.append('ClientId', params.clientId);
    formData.append('File', params.file);
    formData.append('IsDeleteData', `${params.deletePreexistingData}`);
    formData.append('IsBypassStaging', `${params.bypassStaging}`);
    formData.append('UsePreviousRollover', `${params.usePrevRolloverData}`);

    const response = await FetchApi({
        endpoint: 'job/' + params.jobId + '/upload-data',
        method: HTTPMethod.Post,
        apiType: ServiceType.Import,
        body: formData,
    });
    return response;
}

export async function fetchRolloverCount(jobId: Guid) {
	const response = await FetchApi({
		method: HTTPMethod.Get,
		endpoint: ApiUrls.FETCH_ROLLOVER_COUNT_FROM_SETTINGS
        .replace('{jobId}', jobId.toString()),
        headers: {
			'Content-Type': 'application/json',
		},
		apiType: ServiceType.Calculation,
		apiVersion: 2,	
	}).catch((error) => {
		return error;
	});
	return CreateTextResponse(response);
}
